import * as React from "react";

import { IFilter } from "../searchfilter/IFilter";

export interface IDisplayNameContext {
    getDisplayName: (key: keyof IFilter, value: string | null | undefined) => string | undefined;
}

export const DisplayNameContext = React.createContext<IDisplayNameContext | null>(null);
